export default __webpack_public_path__ + "static/chinese-qr-702b96038c525ffc8fe4c62e8150c591.png";